module.exports = __webpack_public_path__ + "static/media/rtstamp.d67e76b3.png";